import { InputHTMLAttributes, useEffect, useRef, useState } from 'react'
import { FieldValues, UseFormRegister } from 'react-hook-form'
import {
    Label,
    ErrorText,
    InputLength,
    InputTextArea
} from 'components/TextArea/styles'

export interface TextAreaProps extends InputHTMLAttributes<HTMLTextAreaElement> {
    register: UseFormRegister<any>
    name: string
    label?: string
    subLabel?: string
    textAreaStyle?: string
    inputWidth?: string
    maxLength?: number
    error?: {
        message: string
    }
    required?: boolean
    noBorder?: boolean
    container?: string
    inputLength?: number
    rows?: number
    onFocus?: (e: any) => void
}

const TextArea: React.FC<TextAreaProps> = ({
    onFocus,
    label,
    register,
    name,
    inputWidth,
    error,
    required,
    container,
    subLabel,
    inputLength,
    rows,
    noBorder,
    maxLength,
    textAreaStyle,
    ...rest
}) => {

    useEffect(() => {
        const textarea = document.getElementById(`textarea-id-${name}`);
        const hasDefaultValue = textarea.getAttribute('defaultValue') !== null;
        let scHeight = textarea.scrollHeight;
        textarea.style.height = `${scHeight}px`;
      
    }, []);


    return (
        <div className={container}>
            {
                label || subLabel ?
                    <span>
                        <Label className="p-0">{label}</Label>
                        <Label className="text-darkGray/80 font-normal whitespace-normal">
                            {subLabel}
                        </Label>
                    </span> : null
            }

            <div className={`flex items-center relative`}>
                <InputTextArea
                    id={`textarea-id-${name}`}
                    onFocus={onFocus}
                    maxLength={maxLength}
                    noBorder={noBorder}
                    error={!error?.message}
                    data-testid="input-label-extarea"
                    {...register(name, {
                        required: required,
                        ...(maxLength ? { maxLength } : {})
                    })}
                    rows={rows}
                    {...rest}
                />

                <ErrorText>{error?.message}</ErrorText>

                {inputLength > 0 && (
                    <InputLength className={inputLength === 0 && 'text-errorText'}>
                        {inputLength}{' '}
                        {inputLength === 1 ? 'caractere' : 'caracteres'}
                    </InputLength>
                )}
            </div>
        </div>
    )
}

export { TextArea }
